import React from "react";
import { useCompleteTokenization } from "../../services/tokenization/completeTokenization";

interface VisaTinkCompleteTokenizationProps {
  providerCode: string;
  state: {
    email: string;
    returnUrl: string;
    [key: string]: any;
  };
}
export const VisaTinkCompleteTokenization: React.FC<
  VisaTinkCompleteTokenizationProps
> = (props) => {
  const { complete, request } = useCompleteTokenization();

  React.useEffect(() => {
    if (!request.data && !request.loading && !request.called) {
      complete(props.state.email, props.state.phoneNumber, {
        providerCode: props.providerCode,
        type: 3,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    if (request.data && !request.loading && request.called) {
      console.log(request);
      if (request.data.completeTokenization === "Token Updated Successfully") {
        window.location.href = props?.state?.url.toString();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [request.data]);

  return <></>;
};
